import React from "react";
import { Info } from "lucide-react";

const GuideSection = ({ title, children, theme }) => {
  return (
    <div className={`text-slate-900 flex flex-col gap-6 rounded-2xl border-2 bg-white hover:shadow-md transition-all location-theme ${theme} border-section`}>
      
      <div className="px-6 pt-6 pb-3">
        <h4 className={`text-[14px] sm:text-[16px] flex items-start gap-2 location-theme ${theme} title-color`}>
          <div className={`p-1.5 rounded-lg location-theme ${theme} icon-bg`}>
            <Info className={`w-4 h-4 location-theme ${theme} icon-color`} />
          </div>
          <span>{title}</span>
        </h4>
      </div>

      <div className="px-6 pb-6">{children}</div>
    </div>
  );
};

export default GuideSection;
